var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadingDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "100%",
      height: "100%"
    },
    viewBox: "0 0 1920 411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_3",
    display: " block",
    transform: "matrix(-57.817832946777344,0,0,57.69166564941406,-203.88502502441406,182.05294799804688) "
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_4",
    transform: "matrix(1,0,0,1,-7.504000186920166,0.4020000100135803) "
  }, /*#__PURE__*/React.createElement("circle", {
    r: 2.72,
    id: "svg_5",
    fillOpacity: 0.4,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "first",
    href: "#svg_5",
    attributeName: "fill-opacity",
    values: "0.4;1;0.4",
    begin: "0s;third.end",
    dur: "0.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "firstR",
    href: "#svg_5",
    attributeName: "r",
    values: "2.72;3.264;2.72",
    begin: "0s;thirdR.end",
    dur: "0.5s"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg_6",
    display: " block",
    transform: "matrix(-56.51422882080078,0,0,56.51422882080078,524.897216796875,182.52627563476562) "
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_7",
    transform: "matrix(1,0,0,1,-7.504000186920166,0.4020000100135803) "
  }, /*#__PURE__*/React.createElement("circle", {
    r: 2.72,
    id: "svg_8",
    fillOpacity: 0.4,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "second",
    href: "#svg_8",
    attributeName: "fill-opacity",
    values: "0.4;1;0.4",
    begin: "0.25s;first.end-0.25s",
    dur: "0.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "secondR",
    href: "#svg_8",
    attributeName: "r",
    values: "2.72;3.264;2.72",
    begin: "0.25s;firstR.end-0.25s",
    dur: "0.5s"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "svg_9",
    display: " block",
    transform: "matrix(-56.51422882080078,0,0,56.51422882080078,1243.897216796875,182.52627563476562) "
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_10",
    transform: "matrix(1,0,0,1,-7.504000186920166,0.4020000100135803) "
  }, /*#__PURE__*/React.createElement("circle", {
    r: 2.72,
    id: "svg_11",
    fillOpacity: 0.4,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "third",
    href: "#svg_11",
    attributeName: "fill-opacity",
    values: "0.4;1;0.4",
    begin: "0.5s;second.end-0.25s",
    dur: "0.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "thirdR",
    href: "#svg_11",
    attributeName: "r",
    values: "2.72;3.264;2.72",
    begin: "0.5s;secondR.end-0.25s",
    dur: "0.5s"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingDots);
export default __webpack_public_path__ + "static/media/loading-dots.ab21f69e0c42a0d371394e8ec65c9225.svg";
export { ForwardRef as ReactComponent };